export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
  NONE = 4,
}

export interface LoggerConfig {
  level?: LogLevel;
  enabled?: boolean;
  prefix?: string;
  showLineNumbers?: boolean;
  useColors?: boolean;
}

export interface PackageLoggerConfig extends LoggerConfig {
  packageName?: string;
  packageEmoji?: string;
}
